import { css } from '@emotion/react';
import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { AiReceptionistOrg } from '@wetags/ai-receptionist';
import { AIRButton } from '@frontend/ai-receptionist-ui';
import { checkAggregateACL } from '@frontend/auth-helpers';
import { useTranslation } from '@frontend/i18n';
import { useGlobalPanel } from '@frontend/panel-engine';
import { useAppScopeStore } from '@frontend/scope';
import { useIsSmallMode, useVoiceAIRCustomizationFlag } from '@frontend/shared';
import { useTooltip } from '@frontend/design-system';
import { AIRSalesDemoTrackingIds } from '../tracking-ids';

export const AIRSalesDemoHeaderTrigger = () => {
  const [isAIRSalesDemoWetagEnabled] = AiReceptionistOrg.useWetag('air-sales-demo-enable');
  const { t } = useTranslation('ai-receptionist');
  const { open } = useGlobalPanel('air-sales-demo');
  const { isSmallMode } = useIsSmallMode();
  const { tooltipProps, triggerProps, Tooltip } = useTooltip({ placement: 'bottom' });

  const { selectedLocationIds } = useAppScopeStore();
  const { isActive: hasVoiceAIRAccess } = useVoiceAIRCustomizationFlag(selectedLocationIds, undefined, 'ALL');

  const { aggregateValue: hasAirCallSimulatorPermission } = checkAggregateACL(
    selectedLocationIds,
    Permission.AIR_CALL_SIMULATOR,
    'all'
  );

  const showTriggerButton = isAIRSalesDemoWetagEnabled && hasVoiceAIRAccess && hasAirCallSimulatorPermission;

  if (!showTriggerButton) {
    return null;
  }

  const buttonProps = isSmallMode
    ? {
        ...triggerProps,
        iconOnly: true,
      }
    : {};

  return (
    <div css={styles.container}>
      <AIRButton
        {...buttonProps}
        onClick={open}
        trackingId={AIRSalesDemoTrackingIds.salesDemoHeaderButton}
        css={styles.button}
      >
        {t('AI Receptionist Demo')}
      </AIRButton>
      {isSmallMode && <Tooltip {...tooltipProps}>{t('AI Receptionist Demo')}</Tooltip>}
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    align-items: center;
    height: 100%;
    padding: var(--fabric-space-gap-xs);
  `,
  button: css`
    max-width: 240px;
  `,
};
